export const setAdminlogin = (status: boolean) => {
    localStorage.setItem('isAdmin', `${status}`);
};

export const isAdminLogin = () => {
    return localStorage.getItem('isAdmin') === 'true';
};